import { getData } from "./rest";
import { objectToQueryString } from "../../utils/api";
import { TopicType } from "../../models/modelTypes";

export const list = async (args: Record<string, unknown>): Promise<{ items: TopicType[]; total: number }> =>
    await getData(`/topic${objectToQueryString(args)}`);

export const get = async (id: number, args: Record<string, unknown>): Promise<TopicType> =>
    await getData(`/topic/${id}${objectToQueryString(args)}`);
